import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackOfferPage } from '@/utils/offerTracking';

export default function OfferLandingTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith('/offer/')) return undefined;
    const params = new URLSearchParams(location.search);
    trackOfferPage(params).catch(() => {});
    return undefined;
  }, [location.pathname, location.search]);

  return null;
}
